import { render, staticRenderFns } from "./Bussiness.vue?vue&type=template&id=5a01ea93&scoped=true"
import script from "./bussiness.js?vue&type=script&lang=js&external"
export * from "./bussiness.js?vue&type=script&lang=js&external"
import style0 from "./bussiness.scss?vue&type=style&index=0&id=5a01ea93&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01ea93",
  null
  
)

export default component.exports